<template>
	<div id="app" :class="{AppHolder:1}" >
		
		<AppTopbar 
			:is_logged_in="is_logged_in" 
			:user="user"
			:logout="logout" 
			/>
		
		<div class="AppPage">
			<div v-if="page_error" >Error loading page</div>
			<router-view v-else />
		</div>

		<AppOverlays />

	</div>
</template>


<script>

	import {ref} from "vue";
	import useAuthStore from "../../stores/AuthStore";
	import useActiveProviderStore from "../../stores/ActiveProviderStore";
	import AppTopbar from "../../components/AppTopbar";
	import AppOverlays from "../../components/AppOverlays";

	export default {

		components:{
			AppTopbar,
			AppOverlays,
		},

		setup() {
			var page_error = ref(false);
			var {user,is_logged_in,logout} = useAuthStore();
			var {provider} = useActiveProviderStore();
			return {
				page_error,
				provider,
				is_logged_in,
				user,
				logout,
			};
		},

		methods:{
			logoutClick(){
				this.logout().then(()=>{
					this.$router.push({name:'Login'});
				});
			}
		}
	}
</script>